import { SStyled } from '../../../styles/theme'
import SBox from '../../opinionless/SBox'
import { mobileMaxWidth } from '../constants'

export const CardSelectStyledContainer = SStyled(SBox)`
    gap: 18px;
    row-gap: 25px;
    
    margin-top: 25px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    
    @media screen and (max-width: ${mobileMaxWidth}) {
        gap: 14px;
        row-gap: 24px;
    }
`
